<template>
  <!-- 揭西县人民医院 -->
  <div class="pageContent">
    <!-- <img
      src="../../../assets/pingdingshan.png"
      alt="Login logo"
      class="loginLogo"
    /> -->
    <div class="hosName">单县正大康复医院</div>
    <div class="ourterTitle">身份证号/手机号/门诊/住院号</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model="name27400007"
          placeholder="请输入绑定信息"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      name27400007: "",
      rules: true,
    };
  },
  methods: {
    inputFn() {
      if (this.name27400007 != "") {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      let institution_id = window.location.href.split("/checkInfoOuter/")[1];
      window.localStorage.setItem("name27400007", this.name27400007);
      window.localStorage.setItem("institution_id", institution_id);
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    let institution_id = window.location.href.split("/checkInfoOuter/")[1];
    if (window.localStorage.getItem("name27400007")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  .hosName {
    font-size: 22px;
    padding: 65px 0 10px;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 15px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
